(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/takeRightWhile', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/takeRightWhile'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.takeRightWhile, global.convert);
    global.takeRightWhile = mod.exports;
  }
})(this, function (exports, _takeRightWhile2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.takeRightWhile = undefined;

  var _takeRightWhile3 = _interopRequireDefault(_takeRightWhile2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Creates a slice of array with elements taken from the end.
   * Elements are taken until predicate returns falsey.
   * The predicate is invoked with three arguments: (value, index, array).
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @example takeRightWhile({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', v => v > 3) // => { nested: { prop: [4] } }
   * @see {@link https://lodash.com/docs#takeRightWhile|lodash.takeRightWhile} for more information.
   * @since 0.3.0
   */
  var takeRightWhile = (0, _convert.convert)(_takeRightWhile3.default);
  exports.takeRightWhile = takeRightWhile;
  exports.default = takeRightWhile;
});